import { TableCell, TableRow } from "@mui/material";
import { ITableColumn } from "../../../../../../App/Typings/Table";
import { useHistory } from "react-router-dom";
import { Check, Close, ErrorOutline } from "@mui/icons-material";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IFeatureTableCellProps {
  columns: ITableColumn[];
  element: any;
}

export default function FeatureTableCell({
  columns,
  element,
}: IFeatureTableCellProps) {
  const history = useHistory();

  function displayIsActive() {
    if (element.isActive) {
      return <Check sx={{ ml: "10%", color: "primary.main" }} />;
    } else {
      return <ErrorOutline sx={{ ml: "10%", color: "secondary.main" }} />;
    }
  }

  function displayRequireAll() {
    if (element.requireAll) {
      return <Check sx={{ ml: "15%", color: "primary.main" }} />;
    } else {
      return <Close sx={{ ml: "15%", color: "secondary.main" }} />;
    }
  }

  return (
    <>
      <TableRow
        hover
        key={element.id}
        sx={classes.rowCell}
        onClick={() =>
          history.push(`/abac/${element.appId}/feature/${element.id}`)
        }
      >
        {columns.map((column: ITableColumn, elementIndex: number) => {
          let value = element[column.propName];
          if (value instanceof Date) {
            value = value.toLocaleDateString("en-US");
          }
          return (
            <TableCell key={elementIndex} align="left" sx={classes.tableCell}>
              {column.propName === "isActive"
                ? displayIsActive()
                : column.propName === "requireAll"
                ? displayRequireAll()
                : value}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}
